import { useState } from "react";
import { Link } from "react-router-dom";
import logo from "../assets/wallpapers/LOGO.png";

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  const navLinks = [
    { name: "Home", path: "/" },
    { name: "About", path: "/about" },
    { name: "Services", path: "/services" },
    { name: "Cars", path: "/cars" },
    { name: "Reviews", path: "/reviews" },
    { name: "Safety Rules", path: "/safety" },
    { name: "Contact", path: "/contact" },
  ];

  return (
    <nav className="bg-gray-900 text-white shadow-xl fixed w-full z-50">
      <div className="max-w-7xl mx-auto px-6 py-5 flex justify-between items-center">
        {/* Logo */}
        <Link to="/" className="flex items-center space-x-3">
          <img
            src={logo}
            alt="Logo"
            className="h-24 w-auto rounded-lg shadow-lg hover:scale-110 transition-transform duration-300"
          />
          <span className="hidden sm:inline text-2xl font-extrabold tracking-wide uppercase text-yellow-400">

          </span>
        </Link>

        {/* Hamburger Button */}
        <button
          className="sm:hidden text-white text-3xl focus:outline-none"
          onClick={() => setIsOpen(!isOpen)}
        >
          ☰
        </button>

        {/* Desktop Menu */}
        <div className="hidden sm:flex items-center space-x-6 font-semibold uppercase">
          {navLinks.map((link) => (
            <Link
              key={link.name}
              to={link.path}
              className="px-4 py-2 rounded-md hover:text-yellow-400 hover:bg-gray-800 transition-all duration-300"
            >
              {link.name}
            </Link>
          ))}
          {/* Emergency Numbers */}
          <div className="ml-6 flex flex-col text-sm font-bold">
            <span className="text-yellow-400">📞 Booking: 77177 76192</span>

          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      <div
        className={`sm:hidden flex flex-col items-center bg-gray-800 overflow-hidden transition-all duration-300 ${
          isOpen ? "max-h-screen py-4" : "max-h-0"
        }`}
      >
        {navLinks.map((link) => (
          <Link
            key={link.name}
            to={link.path}
            className="w-full text-center py-3 border-b border-gray-700 hover:bg-gray-700 uppercase font-bold"
            onClick={() => setIsOpen(false)}
          >
            {link.name}
          </Link>
        ))}

        {/* Booking & Emergency Numbers */}
        <div className="w-full text-center mt-3 text-sm font-bold space-y-1">
          <p className="text-yellow-400">📞 Booking: 77177 76192</p>

        </div>
      </div>
    </nav>
  );
}
